<template>
	<div id="app" style="background-color:#35516d;color: #fff;font-weight: 900;">
		<canvas id="cvs1" style="display: none;"></canvas>
		<div style="height: 50px;text-align: center;padding: 10px;">
			在线Fitting系统
		</div>
		<div style="display: flex;margin-left: 20px;">
			<div style="flex: 2;padding: 10px 20px;font-size: 16px;max-width: 400px;">
				<div v-for="(item, index) in dat" style="padding: 5px;" :key="index">
					<div style="display: flex">
						<div style="width: 160px;">{{item.name}}</div>
						<div v-if="item.color=='green'" style="margin: 0 20px;color: #00B83F;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='yellow'" style="margin: 0 20px;color: #ece864;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='red'" style="margin: 0 20px;color: #b41a3f;width: 60px;">{{item.val}}</div>
						<div>[?]</div>
					</div>
				</div>

			</div>
			<div style="flex: 1;width: 200px;text-align: center;">
				<div style="display: flex;justify-content: center;font-size: 16px;">
					<div>
						<div style="text-align: center">
							髋关节稳定性
						</div>
						<div style="width: 250px;height: 250px;background: #000;margin-top: 10px;">
							<canvas id="cvs6"></canvas>

						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							踝关节稳定性
						</div>
						<div style="width: 250px;height: 250px;background: #000;margin-top: 10px;">
							<canvas id="cvs2"></canvas>
						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							膝关节踏稳定性
						</div>
						<div style="width: 250px;height: 250px;background: #000;margin-top: 10px;">
							<canvas id="cvs3"></canvas>
						</div>
					</div>
				</div>
				<div>
					<button class="btn btn-primary" style="margin-top: 20px;">稳定性重置</button>
				</div>
			</div>
			<div style="flex: 4;display: flex;justify-content: center;">
				<div>

					<div style="width: 500px; height: 500px; background: #000; display: flex; justify-content: center; align-items: center; position: relative;">
						<canvas id="cvs5" style="position: absolute;z-index: 999;"></canvas>
						<video crossOrigin="anonymous" id="vid" autoplay muted loop @play="go_init" src="https://bikecdn.typhcl.cn/fitting/test.mp4" style="position: absolute; max-width: 100%; max-height: 100%;" :controls="false"></video>
					</div>

					<div style="display: flex;justify-content: space-between;">

						<div style="background: #0a2e36;width: 400px;height: 200px;margin-top: 20px;" id="qxt">

						</div>
						<div style="width: 100px;height: 200px;padding-left: 20px;">
							<button :class="'btn '+ (map_name == 'hip' ? 'btn-success' : 'btn-primary')" @click="set_map_name('hip')" style="margin-top: 5px;">髋关节</button>
							<button :class="'btn '+ (map_name == 'knee' ? 'btn-success' : 'btn-primary')" @click="set_map_name('knee')" style="margin-top: 5px;">膝关节</button>
							<button :class="'btn '+ (map_name == 'ankle' ? 'btn-success' : 'btn-primary')" @click="set_map_name('ankle')" style="margin-top: 5px;">踝关节</button>
							<button :class="'btn '+ (map_name == 'elbow' ? 'btn-success' : 'btn-primary')" @click="set_map_name('elbow')" style="margin-top: 5px;">肘关节</button>
							<button :class="'btn '+ (map_name == 'shoulder' ? 'btn-success' : 'btn-primary')" @click="set_map_name('shoulder')" style="margin-top: 5px;">肩关节</button>
							<button :class="'btn '+ (map_name == 'wrist' ? 'btn-success' : 'btn-primary')" @click="set_map_name('wrist')" style="margin-top: 5px;">腕关节</button>

						</div>
					</div>
					<div>
						<button v-if="vst" @click="vst=!vst" class="btn btn-primary " style="margin-top: 20px;margin-right: 10px;">实景视图</button>
						<button v-else @click="vst=!vst" class="btn btn-success" style="margin-top: 20px;margin-right: 10px;">数据视图</button>
						<button v-if="zt" @click="pause()" class="btn btn-primary" style="margin-top: 20px;margin-right: 10px;">暂停</button>
						<button v-else @click="pause()" class="btn btn-success" style="margin-top: 20px;margin-right: 10px;">继续</button>

						<button class="btn btn-success" style="margin-top: 20px;margin-right: 10px;">截图</button>

						<button class="btn btn-success"  style="margin-top: 20px;margin-right: 10px;">完成</button>
					</div>
				</div>

			</div>
		</div>

		<canvas id="cvs4" style="position: absolute;left: -9999px;"></canvas>
	</div>
</template>

<script>
	import * as poseDetection from '@tensorflow-models/pose-detection';
	import * as tf from '@tensorflow/tfjs-core';
	import '@tensorflow/tfjs-backend-webgl';
	var video = null;
	var canvas1 = null;
	var canvas2 = null;
	var canvas3 = null;
	var canvas4 = null;
	var canvas5 = null;
	var canvas6 = null;
	var ctx1 = null;
	var ctx2 = null;
	var ctx3 = null;
	var ctx4 = null;
	var ctx5 = null;
	var ctx6 = null;
	var detector = null;
	var chartDom = null;
	var myChart = null;




	export default {
		name: 'App',
		data() {
			return {
				map_name: "knee",
				option: {
					series: [{
						data: [10, 22, 28, 23, 19],
						type: 'line',
						smooth: true
					}]
				},
				zt: false,
				vst: true,
				jd: ["knee", "hip", "shoulder", "elbow", "ankle", "wrist"],
				dats: {
					"knee": [],
					"hip": [],
					"shoulder": [],
					"elbow": [],
					"ankle": [],
					"wrist": []
				},
				dat_line: {
					"knee": {
						u_max: 148,
						u_min: 138,
						d_max: 73,
						d_min: 67 // 更正为与推荐范围一致
					},
					"hip": {
						u_max: 105,
						u_min: 90,
						d_max: 70,
						d_min: 55
					},
					"shoulder": {
						u_max: 90,
						u_min: 80
					},
					"elbow": {
						u_max: 170,
						u_min: 155
					},
					"ankle": {
						u_max: 130,
						u_min: 100
					},
					"wrist": {
						u_max: 170,
						u_min: 150
					}
				},
				dat: {
					see_fx: {
						name: "视角方向",
						val: "左侧",
						color: "green"
					},
					fknee_min: {
						name: "最小膝前量",
						val: "0",
						color: "green"
					},
					fknee: {
						name: "膝前量",
						val: "0",
						color: "green"
					},
					knee: {
						name: "膝关节当前角度",
						val: "0",
						color: "green"
					},
					knee_max: {
						name: "膝关节最大屈曲角度",
						val: "0",
						color: "green"
					},

					knee_min: {
						name: "膝关节最小收缩角度",
						val: "0",
						color: "red"
					},

					hip: {
						name: "髋关节当前角度",
						val: "0",
						color: "green"
					},
					hip_max: {
						name: "髋关节最大屈曲角度",
						val: "0",
						color: "green"
					},
					hip_min: {
						name: "髋关节最小收缩角度",
						val: "0",
						color: "green"
					},

					shoulder: {
						name: "肩关节当前角度",
						val: "0",
						color: "green"
					},
					shoulder_max: {
						name: "肩关节最大屈曲角度",
						val: "0",
						color: "green"
					},
					shoulder_min: {
						name: "肩关节最小收缩角度",
						val: "0",
						color: "green"
					},

					elbow: {
						name: "肘关节当前角度",
						val: "0",
						color: "green"
					},
					elbow_max: {
						name: "肘关节最大屈曲角度",
						val: "0",
						color: "green"
					},
					elbow_min: {
						name: "肘关节最小收缩角度",
						val: "0",
						color: "green"
					},

					ankle: {
						name: "踝关节当前角度",
						val: "0",
						color: "green"
					},
					ankle_max: {
						name: "踝关节最大屈曲角度",
						val: "0",
						color: "green"
					},
					ankle_min: {
						name: "踝关节最小收缩角度",
						val: "0",
						color: "green"
					},

					wrist: {
						name: "腕关节当前角度",
						val: "0",
						color: "green"
					},
					wrist_max: {
						name: "腕关节最大屈曲角度",
						val: "0",
						color: "green"
					},
					wrist_min: {
						name: "腕关节最小收缩角度",
						val: "0",
						color: "green"
					}

				}
			};
		},
		created() {
			var that = this
			that.init_mode();
		},
		mounted() {
			var that = this
			video = document.getElementsByTagName('video')[0];
			canvas1 = document.getElementById("cvs1");
			canvas2 = document.getElementById("cvs2");
			canvas3 = document.getElementById("cvs3");
			canvas4 = document.getElementById("cvs5");
			canvas5 = document.getElementById("cvs4");
			canvas6 = document.getElementById("cvs6");
			ctx1 = canvas1.getContext("2d");
			ctx2 = canvas2.getContext("2d");
			ctx3 = canvas3.getContext("2d");
			ctx4 = canvas4.getContext("2d");
			ctx5 = canvas5.getContext("2d");
			ctx6 = canvas6.getContext("2d");
			chartDom = document.getElementById('qxt');
			myChart = echarts.init(chartDom);
			setInterval(function() {
				that.ref_map()
			}, 1000);




		},
		methods: {
			set_map_name(name) {
				this.$data.map_name = name;
			},
			ref_map() {
				var that = this;
				var data = that.$data.dats[that.$data.map_name];
				if (data.length > 200) {
					data = data.slice(-200);
				}

				var dataLength = data.length;
				var requiredLength = 200;
				if (dataLength < requiredLength) {
					var padding = new Array(requiredLength - dataLength).fill(90);
					data = padding.concat(data);
				}

				// 获取当前关节的推荐范围
				const range = that.$data.dat_line[that.$data.map_name];
				// 计算最大值和最小值
				const dataMax = Math.max(...data);
				const dataMin = Math.min(...data);

				// 设置y轴范围
				const yAxisMax = dataMax + 10;
				const yAxisMin = dataMin - 10 < 0 ? 0 : dataMin - 10; // 确保最小值不小于0


				var option = {
					animation: false,
					grid: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
						containLabel: false
					},
					xAxis: {
						type: 'category',
						data: [],
						show: false,
					},
					yAxis: {
						type: 'value',
						show: false,
						min: yAxisMin,
						max: yAxisMax
					},
					series: [{
						data: data,
						type: 'line',
						smooth: true,
						itemStyle: {
							color: 'green'
						},
						showSymbol: false,
						lineStyle: {
							width: 2
						},
						markLine: {
							silent: true, // 参考线不响应鼠标事件
							symbol: ['none', 'none'], // 不显示标记线的两端符号，即没有箭头
							data: [{
									yAxis: range.u_min,
									lineStyle: {
										color: '#fff',
										type: 'dashed'
									}
								},
								{
									yAxis: range.u_max,
									lineStyle: {
										color: '#fff',
										type: 'dashed'
									}
								},
							]
						}
					}],
					splitLine: {
						show: true,
						lineStyle: {
							color: '#fff',
							type: 'solid'
						}
					}
				};

				// 如果存在第二组范围，则添加额外的标记线
				if (range.d_min !== undefined && range.d_max !== undefined) {
					option.series[0].markLine.data.push({
						yAxis: range.d_min,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					}, {
						yAxis: range.d_max,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					});
				}

				option && myChart.setOption(option);
			},


			pause() {
				var that = this
				if (!that.$data.zt) {
					video.play();
				} else {
					video.pause();
				}
				that.$data.zt = !that.$data.zt;
			},
			plays() {
				var that = this
				that.end = false;
				video.play()
				that.stas = 2;
			},

			go_init() {
				var that = this

				that.startPoseDetection();
			},
			v_loading() {
				var that = this



				if (typeof(video) == 'undefined') {
					setTimeout(function() {
						that.v_loading();
					}, 500)
				} else {

					if (!video.duration > 0) {
						setTimeout(function() {
							that.v_loading();
						}, 500)
					} else {
						if (video.duration < 10) {
							video.playbackRate = 0.5;
						}




						//that.initPoseDetection();	

					}
				}

			},
			clear() {
				var that = this
				that.dat_list = {

				}
				that.img_list = {

				}
			},
			go_rep() {
				var that = this
				console.log(that.dat_list);
				console.log(that.img_list);

				uni.request({
					url: that.URL, //仅为示例，并非真实接口地址。
					method: "POST",
					data: {
						t: 'u_dat',
						pid: that.pid,
						bid: that.bid,
						dat_list: JSON.stringify(that.dat_list),
						img_list: JSON.stringify(that.img_list),
					},
					success: res => {
						if (that.pt == 'tt') {
							tt.miniProgram.redirectTo({
								url: "/pages/rep/rep?id=" + that.bid
							})
						} else {
							wx.miniProgram.redirectTo({
								url: "/pages/rep/rep?id=" + that.bid
							})
						}


					}
				});
				// uni.setStorageSync("dat_list", that.dat_list);
				// uni.setStorageSync("img_list", that.img_list);




			},
			replay() {
				var that = this
				var videoContext = uni.createVideoContext('vid')
				that.end = false;
				videoContext.play()
				var that = this

			},
			go_end() {
				var that = this
				that.end = true;
				console.log(that.dat_list);
				console.log(that.img_list);
			},
			set_cam_v(rw, rh) {
				var that = this
				return 0;
				that.call += rw + "-" + rh;
				console.log(rw, rh);
				var w = uni.getSystemInfoSync().windowWidth;
				var bf = w / 750;
				that.v_size.w = w;
				that.v_size.h = (750 / rw) * rh * bf;
				that.start = true;

				that.end = true;
				setTimeout(function() {
					//that.initPoseDetection();



					ctx1.drawImage(video, 0, 0, that.v_size.w, that.v_size.h);
				}, 500)


			},
			async initCamera() {
				var that = this
				try {
					var video = document.getElementsByTagName("video")[0];
					console.log(video)
					video.addEventListener('loadedmetadata', function() {
						that.set_cam_v(video.videoWidth, video.videoHeight);
					});
					const stream = await navigator.mediaDevices.getUserMedia({
						video: true
					});
					const videoTrack = stream.getVideoTracks()[0];
					const settings = videoTrack.getSettings();


					video.srcObject = stream;
					video.play();
					try {
						const devices = await navigator.mediaDevices.enumerateDevices();
						that.allVideoDevices = devices.filter(device => device.kind === 'videoinput');
					} catch (error) {
						console.error('Error listing cameras:', error);
					}
					that.stas = 1;
				} catch (error) {
					console.log(error);
					// uni.showModal({
					// 	title: '温馨提示',
					// 	content: '实时分析依赖设备镜头权限，请授权。',
					// 	success: function(res) {
					// 		if (res.confirm) {
					// 			that.initCamera();
					// 		} else if (res.cancel) {
					// 			wx.miniProgram.navigateBack()
					// 		}
					// 	}
					// })
				}


			},
			async sel_v() {
				var that = this
				var arr = [];
				for (var i in that.allVideoDevices) {
					arr.push(that.allVideoDevices[i].label);
				}
				uni.showActionSheet({
					itemList: arr,
					success: async function(res) {
						try {
							const stream = await navigator.mediaDevices.getUserMedia({
								video: {
									deviceId: {
										exact: that.allVideoDevices[res.tapIndex].deviceId
									}
								}
							});

							const videoTrack = stream.getVideoTracks()[0];
							console.log(stream.getVideoTracks);
							const settings = videoTrack.getSettings();
							that.set_cam_v(settings.width, settings.height);

							var video = document.getElementsByTagName("video")[0];
							video.srcObject = stream;
							video.play();
						} catch (error) {
							console.error('Error switching cameras:', error);
							this.call = error;
						}
					},
					fail: function(res) {
						console.log(res.errMsg);
					}
				});
			},
			go_init() {
				var that = this
				var video = document.getElementsByTagName("video")[0];
				console.log(video.videoHeight);
				console.log(video.videoWidth);
				return 0;
				that.begin = true;
				that.startPoseDetection();
			},

			captureCurrentFrame() {
				// 获取现有的两个Canvas元素
				var canvas1 = document.getElementsByTagName('canvas')[0];
				var canvas2 = document.getElementsByTagName('canvas')[1];

				// 创建一个新的Canvas元素
				var mergedCanvas = document.createElement('canvas');
				var ctx = mergedCanvas.getContext('2d');

				// 设置新Canvas的大小以容纳两个Canvas的内容
				var vl = 1 / uni.getSystemInfoSync().pixelRatio;

				mergedCanvas.width = Math.max(canvas1.width, canvas2.width) * vl;
				mergedCanvas.height = Math.max(canvas1.height, canvas2.height) * vl;


				// 在新Canvas上绘制两个现有Canvas的内容
				ctx.scale(vl, vl);
				ctx.drawImage(canvas2, 0, 0);
				ctx.drawImage(canvas1, 0, 0);

				// 将新Canvas转换为Base64编码的图片
				return mergedCanvas.toDataURL('image/png');
			},
			updateAngleAndCaptureImage(jointName, newAngle) { //更新关节
				var that = this
				if (typeof(that.img_list[jointName]) == 'undefined') {
					that.img_list[jointName] = {
						maxAngle: 0,
						minAngle: 360,
						maxImage: '',
						minImage: ''
					}
				}
				var newAngle = parseFloat(newAngle);


				if (newAngle > that.img_list[jointName].maxAngle) {

					that.img_list[jointName].maxAngle = newAngle;
					that.img_list[jointName].maxImage = that.captureCurrentFrame();
				}

				if (newAngle < that.img_list[jointName].minAngle) {
					that.img_list[jointName].minAngle = newAngle;
					that.img_list[jointName].minImage = that.captureCurrentFrame();
				}
			},
			async init_mode() {

				await tf.setBackend('webgl');
				await tf.ready();
				const detectorConfig = {
					landmarkModelUrl: 'https://bikecdn.typhcl.cn/bike/static/land/model.json',
					detectorModelUrl: "https://bikecdn.typhcl.cn/bike/static/dPose/model.json",
					runtime: 'tfjs',
					enableSmoothing: true,
					modelType: 'full'
				};
				detector = await poseDetection.createDetector(poseDetection.SupportedModels.BlazePose, detectorConfig);
				this.sta = "";
				console.log("初始化成功")
				this.startPoseDetection();


			},
			updateColor(value, range) {
				if (value >= range.u_min && value <= range.u_max || (range.d_min !== undefined && value >= range.d_min && value <= range.d_max)) {
					return "green"; // 在推荐范围内
				} else if ((value >= range.u_min - 3 && value < range.u_min) || (value <= range.u_max + 3 && value > range.u_max) || (range.d_min !== undefined && ((value >= range.d_min - 3 && value < range.d_min) || (value <= range.d_max + 3 && value > range.d_max)))) {
					return "yellow"; // 在推荐范围的±3度内
				} else {
					return "red"; // 不在推荐范围内
				}
			},
			u_avg(name, avg) {
				var that = this
				avg = parseFloat(avg);

				// 获取当前关节的推荐范围
				const range = that.$data.dat_line[name];

				if (!range) return; // 如果没有找到对应关节的范围，则直接返回

				let color = "red"; // 默认设置为红色

				// 检查第一组范围
				if (avg >= range.u_min && avg <= range.u_max) {
					color = "green"; // 在推荐范围内
				} else if ((avg >= range.u_min - 3 && avg < range.u_min) || (avg <= range.u_max + 3 && avg > range.u_max)) {
					color = "yellow"; // 在推荐范围的±3度内
				}

				// 如果存在第二组范围，也进行检查
				if (range.d_min !== undefined && range.d_max !== undefined) {
					if (avg >= range.d_min && avg <= range.d_max) {
						color = "green"; // 在第二组推荐范围内
					} else if ((avg >= range.d_min - 3 && avg < range.d_min) || (avg <= range.d_max + 3 && avg > range.d_max)) {
						color = color === "green" ? "green" : "yellow"; // 如果已经是绿色，则保持不变，否则设为黄色
					}
				}

				// 更新颜色和角度值
				that.$data.dat[name].color = color;
				that.$data.dat[name].val = avg.toFixed(1);

				// 更新角度数据数组
				if (that.$data.dats[name].length == 0 || that.$data.dats[name][that.$data.dats[name].length - 1] != avg) {
					that.$data.dats[name].push(avg);
				}

				that.$data.dat[name].val = parseFloat(avg).toFixed(1);
				if (that.$data.dat[name + "_min"].val < avg || that.$data.dat[name + "_min"].val == "0") {
					that.$data.dat[name + "_min"].val = parseFloat(avg).toFixed(1);
					that.$data.dat[name + "_min"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
				}
				if (that.$data.dat[name + "_max"].val > avg || that.$data.dat[name + "_max"].val == "0") {
					that.$data.dat[name + "_max"].val = parseFloat(avg).toFixed(1);
					that.$data.dat[name + "_max"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
				}
				// var sum=0;
				// for(var i in that.$data.dats[name]){
				// 	sum+=parseFloat(that.$data.dats[name][i])
				// }				
				// that.$data.dat[name+"_avg"].val=(sum/that.$data.dats[name].length).toFixed(1);

			},
			updateknee_x(newAngles, showLeftSide) { //更新关节
				var that = this



				if (showLeftSide) {
					that.dat.fknee.val = (newAngles[0][0] - newAngles[1][0]).toFixed(1);
					if (that.dat.fknee_min.val > that.dat.fknee.val || that.dat.fknee_min.val == "0") {
						that.dat.fknee_min.val = that.dat.fknee.val
					}
				} else {
					that.dat.fknee.val = (newAngles[1][0] - newAngles[0][0]).toFixed(1);
					if (that.dat.fknee_min.val > that.dat.fknee.val || that.dat.fknee_min.val == "0") {
						that.dat.fknee_min.val = that.dat.fknee.val
					}
				}



			},
			async initPoseDetection() {
				var that = this
				if (that.sta == "") {
					console.log("创建成功");
					that.end = false;

					setTimeout(function() {
						that.stas = 2;
						that.startPoseDetection();

					}, 1500)
				} else {

					setTimeout(function() {
						that.initPoseDetection();
					}, 1500)
				}


			},
			calculateAngle(pt1, pt2, pt3) {
				const a = Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
				const b = Math.sqrt(Math.pow(pt2.x - pt3.x, 2) + Math.pow(pt2.y - pt3.y, 2));
				const c = Math.sqrt(Math.pow(pt3.x - pt1.x, 2) + Math.pow(pt3.y - pt1.y, 2));
				const angle = Math.acos((a * a + b * b - c * c) / (2 * a * b));
				var dat = angle * (180 / Math.PI);
				return dat.toFixed(2);
			},
			async startPoseDetection() {
				var that = this
				var vh = video.videoHeight;
				var vw = video.videoWidth;

				var dat_knee = [
					[0, 0],
					[0, 0]
				];
				canvas5.width = video.offsetWidth;
				canvas5.height = video.offsetHeight;
				canvas4.width = video.offsetWidth;
				canvas4.height = video.offsetHeight;
				canvas1.width = video.offsetWidth / 2;
				canvas1.height = video.offsetHeight / 2;
				canvas6.width = video.offsetWidth / 2;
				canvas6.height = video.offsetHeight / 2;
				canvas2.width = video.offsetWidth / 2;
				canvas2.height = video.offsetHeight / 2;
				canvas3.width = video.offsetWidth / 2;
				canvas3.height = video.offsetHeight / 2;
				var vl = 1;
				const poseDetectionLoop = async () => {

					ctx5.drawImage(video, 0, 0, video.offsetWidth, video.offsetHeight);

					const estimationConfig = {
						flipHorizontal: false
					};
					// console.log(video);
					var videos = document.getElementById("vid");
					const poses = await detector.estimatePoses(canvas5, estimationConfig);
					poses.forEach(pose => {
						if (!that.$data.zt) {
							return 0;
						}
						ctx4.clearRect(0, 0, canvas4.width, canvas4.height);
						if (!that.$data.vst) {
							ctx4.fillStyle = '#000000'; // 或 ctx4.fillStyle = 'black';

							// 使用fillRect绘制黑色背景覆盖整个canvas
							ctx4.fillRect(0, 0, canvas4.width, canvas4.height);
						}
						if (pose.score > 0.95) {

							const head = pose.keypoints.find(k => k.name === 'nose');
							// Assuming you have separate keypoints for left and right hips
							const leftHip = pose.keypoints.find(k => k.name === 'left_hip');
							const rightHip = pose.keypoints.find(k => k.name === 'right_hip');

							if (head && leftHip && rightHip) {


								const showLeftSide = head.x < (leftHip.x + rightHip.x) / 2;
								var dat_knee = [
									[0, 0],
									[0, 0]
								];

								pose.keypoints.forEach(({
									x,
									y,
									name
								}) => {
									x = x * vl.toFixed(2);
									y = y * vl.toFixed(2);
									var side_list = ["knee", "hip", "ankle", "shoulder", "elbow", "wrist"];
									for (var ix in side_list) {
										if (name.includes(showLeftSide ? 'left_' + side_list[ix] : 'right_' + side_list[ix])) {
											const leftHipX = x; // x坐标
											const leftHipY = y; // y坐标
											ctx4.beginPath(); // 开始新路径
											ctx4.arc(leftHipX, leftHipY, 8, 0, 2 * Math.PI); // 绘制圆：圆心x, 圆心y, 半径, 起始角度, 结束角度
											ctx4.fillStyle = '#0e00f1'; // 设置填充颜色
											ctx4.fill(); // 填充圆
											ctx4.strokeStyle = '#0e00f1'; // 设置边框颜色
											ctx4.lineWidth = 2; // 设置线宽
											ctx4.stroke(); // 绘制圆的边框										
										}
									}
									if (name.includes(showLeftSide ? 'left_hip' : 'right_hip')) {


										ctx6.beginPath();
										ctx6.arc(x / 2, y / 2, 1, 0, 1 * Math.PI);
										ctx6.fillStyle = '#0af5d8';
										ctx6.fill();

									}
									if (name.includes(showLeftSide ? 'left_ankle' : 'right_ankle')) {

										ctx2.beginPath();
										ctx2.arc(x / 2, y / 2, 1, 0, 1 * Math.PI);
										ctx2.fillStyle = '#0af5d8';
										ctx2.fill();
									}
									if (name.includes(showLeftSide ? 'left_knee' : 'right_knee')) {
										ctx3.beginPath();
										ctx3.arc(x / 2, y / 2, 1, 0, 1 * Math.PI);
										ctx3.fillStyle = '#0af5d8';
										ctx3.fill();
									}
									if (name.includes(showLeftSide ? 'left_knee' : 'right_knee')) {
										const leftHipX = x;
										const leftHipY = y;
										ctx4.beginPath();
										ctx4.arc(x, y, 1, 0, 1 * Math.PI);
										ctx4.fillStyle = '#0af5d8';
										ctx4.fill();

										dat_knee[0] = [leftHipX, leftHipY]

									}
									if (name.includes(showLeftSide ? 'left_foot_index' : 'right_foot_index')) {
										const leftHipX = x;
										const leftHipY = y;
										dat_knee[1] = [leftHipX, leftHipY]
									}
									ctx4.strokeStyle = 'blue';
									ctx4.lineWidth = 2;
									var limbs = showLeftSide ? [
										// 左侧
										['left_shoulder', 'left_hip', 'left_knee'], // 髋关节角度
										['left_hip', 'left_knee', 'left_ankle'], // 膝关节角度
										['left_knee', 'left_ankle',
											'left_foot_index'
										], // 踝关节角度
										['left_elbow', 'left_shoulder', 'left_hip'], // 肩关节角度
										['left_shoulder', 'left_elbow', 'left_wrist'], // 肘关节角度
										['left_index', 'left_wrist', 'left_elbow'], // 腕关节角度
									] : [
										['right_shoulder', 'right_hip', 'right_knee'], // 髋关节角度
										['right_hip', 'right_knee', 'right_ankle'], // 膝关节角度
										['right_knee', 'right_ankle',
											'right_foot_index'
										], // 踝关节角度
										['right_elbow', 'right_shoulder', 'right_hip'], // 肩关节角度
										['right_shoulder', 'right_elbow', 'right_wrist'], // 肘关节角度
										['right_index', 'right_wrist', 'right_elbow'], // 腕关节角度
									];

									limbs.forEach(limb => {
										if (limb.length === 3) {

											const [startPart, middlePart, endPart] = limb;
											var names = middlePart.split("_")[1];
											const startKeypoint = pose.keypoints.find(k =>
												k
												.name ===
												startPart);
											const middleKeypoint = pose.keypoints.find(k =>
												k
												.name ===
												middlePart);
											const endKeypoint = pose.keypoints.find(k => k
												.name ===
												endPart);

											if (startKeypoint && middleKeypoint && endKeypoint) {
												// 计算角度
												const angle = that.calculateAngle(startKeypoint, middleKeypoint, endKeypoint);
												if (side_list.includes(names)) {

													that.u_avg(names, angle);
												}

												// if (typeof(that.dat_list[limb[1]]) =='undefined') {
												// 	that.dat_list[limb[1]] = [];
												// }
												// that.dat_list[limb[1]].push(angle);

												// 绘制连线
												ctx4.beginPath();
												ctx4.moveTo(startKeypoint.x * vl, startKeypoint.y * vl);
												ctx4.lineTo(middleKeypoint.x * vl, middleKeypoint.y * vl);
												ctx4.lineTo(endKeypoint.x * vl, endKeypoint.y * vl);
												ctx4.strokeStyle = '#1db415';
												ctx4.lineWidth = 4;
												ctx4.stroke();
												// 显示角度
												// ctx4.fillStyle = '#0af5d8';
												// ctx4.font = '18px Arial';
												// ctx4.fillText(parseInt(angle) + '°',middleKeypoint.x * vl + 10,middleKeypoint.y * vl + 10);									
												//that.updateAngleAndCaptureImage(limb[1], angle);

											}
										}
									});
									that.updateknee_x(dat_knee, showLeftSide);

								});


							}
						}

					});

					requestAnimationFrame(poseDetectionLoop);
				};

				poseDetectionLoop();





			}
		}
		// 可能的计算属性和方法...
	};
</script>

<style>

</style>